import React from "react";
import Grid from "@mui/material/Grid";

import { makeStyles } from "@material-ui/core/styles";
import AssignmentTabs from "./AssignmentTabs";

const Assignment = (props) => {
  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid sx={{ position: "relative" }}>
          <Grid
            container
            className={classes.scrollBarHeight}
            sx={{
              flexDirection: "row",
              flexWrap: "nowrap",
              justifyContent: "flex-start",
              overflow: "auto",
              width: "95%",
              marginLeft: 4,
              borderTopLeftRadius: 15,
              borderTopRightRadius: 15,
            }}
          >
            <AssignmentTabs />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default Assignment;
